import { Form, Input, message, Modal } from "antd";
import React from "react";
import { useDispatch } from "react-redux";
import { searchPartner } from "../../feature/referral-partners/referralPartnerApi";
import DebounceSelect from "../../components/DebounceSelect";
import { createPartnerTrackingRequest } from "../../feature/partner-tracking/partnerTrackingSlice";

const AddTracking = ({ onCancel }) => {
  const dispatch = useDispatch();

  const [form] = Form.useForm();

  const onCreate = (values) => {
    dispatch(
      createPartnerTrackingRequest({
        ...values,
        partnerId: values.partnerId.value,
      })
    );
  };

  const fetchPartnerList = async (name) => {
    return searchPartner(name).then((res) => {
      const listPartner = res.data.map((partner) => ({
        label: `${partner.firstName} ${partner.lastName}`,
        value: partner._id,
      }));
      listPartner.unshift({
        label: "--/--",
        value: null,
      });
      return listPartner;
    });
  };

  const validatePartner = () => {
    if (form.getFieldValue(["partner"])?.value === null) {
      form.setFields([
        {
          name: "partner",
          errors: ["Please input partner!"],
        },
      ]);
      return false;
    }
    return true;
  };

  return (
    <Modal
      title={"Add Tracking"}
      visible={true}
      width={"80%"}
      className="modal-w-600"
      onOk={() => {
        form
          .validateFields()
          .then((values) => {
            if (!validatePartner()) return;
            onCreate(values);
            form.resetFields();
            onCancel();
          })
          .catch((info) => {
            if (!validatePartner()) return;
            message.error("Validate failed!");
            console.log("Validate Failed:", info);
          });
      }}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
    >
      <div className="add-tracking-link-container">
        <Form form={form} name="basic" className="row-col">
          <Form.Item
            className="custom-form-item"
            name="code"
            label="Tracking Link Code (no spaces, keep it short)&#42;"
            rules={[
              { required: true, message: "Please input code!" },
              {
                pattern: new RegExp("^[a-zA-Z0-9]*$"),
                message:
                  "Value is only number & char, no special char, no space",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            className="custom-form-item"
            name="partnerId"
            label={<div>Referral Partner&#42;</div>}
            rules={[{ required: true, message: "Please input partner!" }]}
          >
            <DebounceSelect
              className="w-100-p"
              fetchOptions={fetchPartnerList}
            />
          </Form.Item>

          <Form.Item
            className="custom-form-item"
            name="userEmail"
            label={<div>User Email&#42;</div>}
            rules={[
              { required: true, message: "Please input user!" },
              {
                type: "email",
                message: "The input is not valid email!",
              },
            ]}
          >
            <Input />
          </Form.Item>

          <Form.Item
            className="custom-form-item"
            name="userFirstName"
            label="User First Name"
          >
            <Input />
          </Form.Item>

          <Form.Item
            className="custom-form-item"
            name="userLastName"
            label="User Last Name"
          >
            <Input />
          </Form.Item>
        </Form>
      </div>
    </Modal>
  );
};

export default AddTracking;
